// Copyright (c) 2024 Lenovo. All right reserved.
// Confidential and Restricted
import { userLanguage } from '@/utils/utils';
import VueI18n from "vue-i18n";
import Vue from "vue";
import ar from '@/locales/ar';
import bgBg from '@/locales/bg-bg';
import csCz from '@/locales/cs-cz';
import daDk from '@/locales/da-dk';
import de from '@/locales/de';
import elGr from '@/locales/el-gr';
import en from '@/locales/en';
import es from '@/locales/es';
import fiFi from '@/locales/fi-fi';
import fr from '@/locales/fr';
import hr from '@/locales/hr';
import huHu from '@/locales/hu-hu';
import inId from '@/locales/in-id';
import it from '@/locales/it';
import iwIl from '@/locales/iw-il';
import ja from '@/locales/ja';
import ko from '@/locales/ko';
import nb from '@/locales/nb';
import nl from '@/locales/nl';
import plPl from '@/locales/pl-pl';
import ptBr from '@/locales/pt-br';
import ptPt from '@/locales/pt-pt';
import roRo from '@/locales/ro-ro';
import ruRu from '@/locales/ru-ru';
import skSk from '@/locales/sk-sk';
import slSi from '@/locales/sl-si';
import sr from '@/locales/sr';
import sv from '@/locales/sv';
import th from '@/locales/th';
import trTr from '@/locales/tr-tr';
import ukUa from '@/locales/uk-ua';  
import zh from '@/locales/zh';     // chinese
import zhHant from '@/locales/zhHant';  //chinese-Hant

/**
 * Add custom callback functions in multiple languages
 */
VueI18n.prototype.customChangeCallback = function() {

}

VueI18n.prototype.changeLanguage = function changeLanguage(languageKey) {
  const languageKeyObj = {

  };
  this.locale = languageKeyObj[languageKey];
}

Vue.use(VueI18n);

/*
  this.$i18n.locale = lang; // switch
  {{ $t('message.hello') }} // use
*/

import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

const i18n = new VueI18n({
  locale: userLanguage, // 设置默认语言
  messages: {
    ar, // 阿拉伯语 ar
    bgBg, // 保加利亚语 bg
    csCz, // 捷克语 cs
    daDk, // 丹麦语 da
    de, // 德语 de
    elGr, // 希腊语 el
    en: Object.assign(en, enLocale),
    es, // 西班牙语 es
    fiFi, // 芬兰语 fi
    fr, // 法语 fr
    hr, // 克罗地亚语 hr
    huHu, // 匈牙利语 hu
    inId, // 印尼语 id
    it, // 意大利语 it
    iwIl, // 希伯来语, he
    ja, // 日本语 ja
    ko, // 韩语 ko
    nb, // 挪威语 nb
    nl, // 荷兰语 nl
    plPl, // 波兰语 pl
    ptBr, // 巴西葡萄牙语 原：pt 改：ptBr
    ptPt, // 葡萄牙葡萄牙语 原：pt 改：ptPt
    roRo, // 罗马尼亚语 ro
    ruRu, // 俄语 ru
    skSk, //斯洛伐克语 sk
    slSi, // 斯洛文尼亚语 sl
    sr, // 塞尔维语言 sr
    sv, // 瑞典语 sv
    th, // 泰语 th
    trTr, // 土耳其语 tr
    ukUa, // 乌克兰语 uk
    zh: Object.assign(zh, zhLocale), // 中国 zh
    zhHant // 繁体中文 zhHant
  }
})

const getTanStr = function(msg = '', param) {
  return i18n.t('msg.' + msg);
}
/**
 * 全局翻译
 * @param  {
 *  {
 *    tranStr: String;
 *    params: String;
 *  }
 *  String
 * } msg 
 * @param {*} param 
 * @returns 返回翻译后的串
 */




let temTranStr = '', temStr = null, temMessages = i18n.messages, temMsg = null;
Vue.prototype.$tran = function(msg, param) {
  temMsg = temMessages[i18n.locale].msg;
  if(!temMsg[msg] && !temMsg[param]) return msg;
  if(param) {
    let temParam = i18n.t('msg.' + param).replace('msg.', '').toLocaleLowerCase();
    return i18n.t('msg.' + msg, { param: temParam }).replace('msg.', '');
  } else {
    temTranStr = i18n.t('msg.' + msg).replace('msg.', '');
    
    return (!temTranStr || 'null,undefined'.includes(temTranStr.toString())) ? '' : temTranStr;
  }
}

export default i18n;